import './index.scss'
$("#nav3").addClass("active");